import _extends from 'babel-runtime/helpers/extends';

import CreativeLib from '@/views/repository/components/creativeLib.vue';

export default {
  props: {
    resourceTypeId: {
      type: [Number],
      required: true
    },

    updating: {
      type: Boolean,
      default: false
    },

    visible: {
      type: Boolean,
      required: true
    },

    dialogAttrs: {
      type: Object
    },

    mutiple: {
      type: Boolean,
      default: true
    },

    query: {
      type: Object,
      default: function _default() {}
    },

    formItem: {
      type: Object,
      default: function _default() {}
    }
  },

  components: {
    CreativeLib: CreativeLib
  },

  data: function data() {
    return {
      resourceIds: [],
      resourceItems: []
    };
  },


  computed: {
    creativeLibSelectConfig: function creativeLibSelectConfig() {
      return {
        type: this.mutiple ? 'checkbox' : 'radio',
        defaultList: [],
        handleChange: this.selectResource
      };
    },

    innerVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        if (val === false && this.beforeClose()) {
          this.reset();
          this.$emit('update:visible', val);
        }
      }
    },

    innerDialogAttrs: function innerDialogAttrs() {
      var _this = this;

      return _extends({
        title: '云端选择资源',
        width: '100%',
        customClass: 'resources-select-dialog',
        fullscreen: true,
        closeOnPressEscape: false,
        appendToBody: true,
        beforeClose: function beforeClose(done) {
          if (_this.beforeClose()) done();
        }
      }, this.dialogAttrs);
    },
    submitButton: function submitButton() {
      return {
        loading: this.updating,
        type: 'primary',
        disabled: this.mutiple ? this.resourceIds.length === 0 : !this.resourceIds
      };
    }
  },

  methods: {
    beforeClose: function beforeClose() {
      if (this.updating) {
        this.$message.warning('更新素材期间不允许关闭弹窗');
        return false;
      }
      return true;
    },
    submit: function submit() {
      this.$emit('submit', this.resourceIds, this.resourceItems);
    },
    reset: function reset() {
      this.resourceIds = this.mutiple ? [] : '';
    },
    selectResource: function selectResource(ids, items) {
      console.log(ids);
      console.log(items);
      this.resourceIds = ids;
      this.resourceItems = items;
    }
  }
};